import ContentInlineFrame from './ContentInlineFrame'

export default ContentInlineFrame
